
export function slugify(string: string): string {
  return string.toString().toLowerCase().trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, '') // Remove non-alphanumeric and non-hyphen characters
    .replace(/\-\-+/g, '-') // Replace multiple consecutive hyphens with single hyphen
    .replace(/^-+/, '') // Remove leading hyphens
    .replace(/-+$/, ''); // Remove trailing hyphens
}